import React from "react";
import Rows from "./rows";

const ConfigLayout = (props) => {
  let finalProps = Object.entries(props)
    .filter(([key]) => key !== "props")
    .map(([key, value]) => ({
      section: key,
      props: value,
    }));

  const sectionProps = props?.props;

  return (
    <main className="config-layout-default">
      <div className="container">
        <div className="default-container">
          {finalProps &&
            finalProps.map(({ section, props }, index) => {
              const finalRows = Object.entries(props).map(([key, value]) => {
                if (key.includes("row")) {
                  return value;
                }
              });

              return (
                <Rows
                  category={section}
                  title={props?.title}
                  subtitle={props?.subtitle}
                  selectType={props?.selectType}
                  rows={finalRows}
                  number={index}
                />
              );
            })}
        </div>
      </div>

      <style jsx>
        {`
          .config-layout-default {
            ${sectionProps?.["background-color"]
              ? `background-color: ${sectionProps?.["background-color"]};`
              : ""}

            .default-container {
              width: 100%;
              margin-top: 2rem;
              margin-bottom: 1rem;
            }
          }
        `}
      </style>
    </main>
  );
};

export default ConfigLayout;
